export class Control {
  constructor(
    public hash?: string,
    public name?: string,
    public protocol?: string
  ) { }

  clone() {
    return new Control(
      this.hash,
      this.name,
      this.protocol
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/control.ts